<script>
    export let color = 'white';
    export let size = 50;
    export let position = 'relative';
    export let bg = false;
</script>

{#if bg}
<div class="fixed top-0 left-0 w-full h-full bg" style="background:rgba(0,0,0,.1)"></div>
{/if}
<div class="spinner-holder {position} {$$props.class || ''}">

  <svg
      class="spinner {position}"
      viewBox="0 0 50 50"
      style="width: {size}px; height: {size}px; {$$props.style || ''}">
      <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={color}
          stroke-width="5"
      />
  </svg>
</div>

<style type="text/scss">
    .bg {
      z-index: 10000
    }
    .spinner-holder {
      width:50px;
      height:50px;
      &.fixed {
        position:fixed;
        top:50%;
        left:50%;
      }

      &.absolute {
        position:absolute;
        top:50%;
        left:50%;
      }
    }

    .spinner {
        animation: rotate 2s linear infinite;

        .path {
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }

    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
</style>
